import { Box, SystemProps, Text, LegacyText, TransparentButton } from "flicket-ui";
import styled from "styled-components";

import { useAtom } from "jotai";
import { Icon } from "~components";
import { ticketDetailsAtom, Details } from "../../common/modal.TicketDetails";
import { googleAnalyticsReleaseAtom } from "~hooks/useGoogleAnalyticsPageView";
import { useOrganization } from "~hooks";
import { trackViewItem } from "~lib/helpers/googleAnalyticsTracking";

const ToolTip = styled(Box)<SystemProps>`
  position: relative;

  &&& button:hover {
    color: ${(p) => p.theme.colors.N600};
    opacity: 0.8;
    transition: background 0.2s, box-shadow 0.15s, border-color 0.2s, color 0.2s,
      opacity 0.2s;
  }
`;

type ListItemDetailsProps = Details & {
  ticketType?: any;
};

export const ListItemDetails = ({
  description,
  restrictions,
  name,
  ticketType,
  ticketImage,
  addonImage,
}: ListItemDetailsProps) => {
  const [, setTicketDetails] = useAtom(ticketDetailsAtom);

  const { organization } = useOrganization();
  const [release] = useAtom(googleAnalyticsReleaseAtom);

  if (!description && !restrictions) {
    return null;
  }
  return (
    <ToolTip>
      <TransparentButton
        color="N600"
        onClick={() => {
          //  @ts-expect-error atom type issue while using strict:false
          setTicketDetails({
            name,
            description,
            restrictions,
            ticketImage,
            addonImage,
          });
          trackViewItem({
            currency: organization?.currency,
            id: release?.event?.id,
            name: release?.event?.title,
            ticketType,
            isSeated: true,
            releaseName: release?.name,
            releaseId: release?.id,
          });
        }}
      >
        <Icon color="N500" icon="info" fontSize={3} mr="1/2" />
        <LegacyText fontSize={2} fontWeight="medium" lineHeight="medium">
          Details
        </LegacyText>
      </TransparentButton>
    </ToolTip>
  );
};

export default ListItemDetails;
